import type { Translate } from 'common/providers/LocaleProvider';
import { isTranslationAvailable, useLocalization } from 'common/providers/LocaleProvider';

interface HelpLink {
  label: string;
  href: string;
}

const A11Y_CONTENT = 'other_requests.legal_concerns.accessibility_content';

const areTranslationsAvailable = (reason: string, t: Translate) => {
  const label = t(`h24_help_link_${reason}_first_label`);
  const href = t(`h24_help_link_${reason}_first_href`);

  return label && href && isTranslationAvailable(label) && isTranslationAvailable(href);
};

const getHelpLinksForReason = (reason: string, t: Translate) =>
  [
    {
      label: t(`h24_help_link_${reason}_first_label`),
      href: t(`h24_help_link_${reason}_first_href`),
    },
    {
      label: t(`h24_help_link_${reason}_second_label`),
      href: t(`h24_help_link_${reason}_second_href`),
    },
    {
      label: t(`h24_help_link_${reason}_third_label`),
      href: t(`h24_help_link_${reason}_third_href`),
    },
  ].filter(({ label, href }) => isTranslationAvailable(label) && isTranslationAvailable(href));

export const useHelpLinks = (reason: string): HelpLink[] => {
  const { t } = useLocalization();

  const category = reason.split('.')[0];
  const subCategory = reason.split('.')[1] ?? null;

  const subCategoryReason = subCategory ? [category, subCategory].join('.') : null;

  if (reason === A11Y_CONTENT) {
    return [];
  } else if (areTranslationsAvailable(reason, t)) {
    return getHelpLinksForReason(reason, t);
  } else if (subCategoryReason && areTranslationsAvailable(subCategoryReason, t)) {
    return getHelpLinksForReason(subCategoryReason, t);
  } else if (areTranslationsAvailable(category, t)) {
    return getHelpLinksForReason(category, t);
  }

  return [];
};
